import { backendBaseUrl } from '../utils/platformBasedInfo';
import { useAxios } from './axiosInstance';
import { UseAxiosResult } from 'axios-hooks';
import { useEnrichWithCommonValues } from './enrichWithCommonValues';

export const ENDPOINT_PATCH_OPPORTUNITY = `${backendBaseUrl}/deals`;

export const updateLoaneeDeal = (): UseAxiosResult => {
  const { enrich } = useEnrichWithCommonValues();
  const [{ data, loading, error }, update] = useAxios(
    {
      url: ENDPOINT_PATCH_OPPORTUNITY,
      withCredentials: true,
      method: 'PATCH',
    },
    { manual: true }
  );

  return [{ data, loading, error }, enrich(update), () => {}];
};
